export var Badge = {
    baseStyle: {
        borderRadius: '6px',
        padding: '1px 6px',
        fontWeight: 'medium',
        textTransform: 'capitalize',
    },
};
